import { restoreTokens } from '@/contexts/Auth/authTokens';

import { refreshTokens } from '../../api/auth';
import { emit } from '../../eventBus';

import TokenManager from './TokenManager';

type RequestCallback = (headers: Headers) => Promise<Response>;

let refreshTokenPromise: Promise<unknown> = Promise.resolve();
const MAX_REQUESTS = 5;

const reauth = async (headers: Headers, cb: RequestCallback, tryiesCounter = 0): Promise<Response> => {
  if (tryiesCounter > MAX_REQUESTS) {
    emit({ action: 'logout' });
    throw new Error('too much requests');
  }
  const tokenManager = TokenManager.getInstance();
  const accessToken = tokenManager.getAccessToken();

  headers.set('authorization', `Bearer ${accessToken}`);

  const response = await cb(headers);

  if (response.ok) return response;

  if (![401, 403].includes(response.status)) {
    // Will be handled by next Guard
    return response;
  }

  try {
    const tokens = await (refreshTokenPromise = refreshTokens({ refreshToken: (await restoreTokens()).refresh_token }));

    emit({ action: 'login', tokens: tokens });
  } catch (e: unknown) {
    refreshTokenPromise = Promise.resolve();
    throw e;
  }

  return reauth(headers, cb, tryiesCounter + 1);
};

export const authMiddleware = async (cb: RequestCallback, headers?: Headers): Promise<Response> => {
  await refreshTokenPromise;

  return reauth(headers || new Headers(), cb);
};
